<h2 mat-dialog-title i18n="my documents upload document file size warning title@@my-documents-upload-document-file-size-warning-title">File is too large</h2>
<mat-dialog-content class="content-message mb-4">
    <span>
        <ng-container i18n="my documents upload document file size warning message@@my-documents-upload-document-file-size-warning-message">
            Please upload the file from your
        </ng-container>
        <app-action-link [href]="onedriveLink" [target]="'_blank'">
            <span i18n="onedrive text@@onedrive-text">Onedrive</span>
        </app-action-link>.
    </span>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="accent" i18n="close text@@close-text">Close</button>
</mat-dialog-actions>
